import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-maintenance',
  imports: [RouterLink],
  templateUrl: './maintenance.html',
  styleUrl: '../service-pages.scss',
})
export class Maintenance {}
